import { Card, CardProps } from '@mui/material'

interface IOvCardProps extends CardProps {
  children: React.ReactNode
}

export const OvCard = ({ children, sx, ...rest }: IOvCardProps) => {
  return (
    <Card
      sx={{ padding: 3, ...sx }}
      {...rest}>
      {children}
    </Card>
  )
}
